module.exports = __webpack_public_path__ + "static/media/faq_2.5ddfa496.png";